/**
 * Created by mykurisu on 2017/9/6.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios'
import {Preload, ClickLoadMore, InfiniteScroll, WKToShareCard, Page, Pay} from '../components'
import {WKCurrencyItem, WKOperation, WKOwnDialog} from '../components/wk'
import {PushComponent, CouponBar, CouponSelected, CouponPay} from '../components/details'
import {LoadMore, Toast} from 'react-weui'
import {renderMoney, TimeStream, isLZWKAPP, judgeAPPVersion, isIos} from '../utils';
import { wxPay, updateSuccess, goBack } from '../utils/connectApp'
import '../css/page/LiveroomVipPage.css'
import VipBG from '../images/liveroom/liveroom-vip-bg.png'
import VipCard from '../images/liveroom/liveroom-vip-card.png'
import LiveroomBarAngle from '../images/liveroom/new-wk-angle.png'
import LiveroomVipFree from '../images/liveroom/liveroom-vip-free.png'
import LiveroomVipRespected from '../images/liveroom/liveroom-vip-respected.png'
import PushLecture from '../images/lecture/push-lecture.png'


class LiveroomTitleBar extends React.Component {
    render() {
        return (
            <div className="title-bar">
                <span></span>
                {this.props.title}
            </div>
        )
    }
}


class LiveroomVipPage extends React.Component {

    constructor() {
        super();
        this.state = {
            init: false,
            liveroom: null,
            channel: null,
            lecture: null,
            channelLoading: false,
            lectureLoading: false,
            push_show: false,
            couponpay_show: false,
            isShowSuccessToast: false,
            isPending: false,
            isShowNoEnoughAlert: false,
            noEnoughtMsg: '',
            // showVIPBtn: false
        }
        this.handleCouponPayShow = this.handleCouponPayShow.bind(this)
        // this.oneShowVIPBtn = this.oneShowVIPBtn.bind(this);
    }

    componentDidMount() {
        // 初始化店铺数据
        let {liveroom_id} = this.props.location.query;
        let liveroomInfoParams = {}
        if (this.props.location.query.st) {
            liveroomInfoParams = { ...liveroomInfoParams, st: this.props.location.query.st }
        }
        if (this.props.location.query.inviter_id) {
            liveroomInfoParams = { ...liveroomInfoParams, inviter_id: this.props.location.query.inviter_id }
        }
        axios.get(`/api/liveroom/${liveroom_id}/vip/info`, {
            params: liveroomInfoParams,
        }).then(res => {
            if (res.data.code === 1){
                window.location = `/liveroom/${liveroom_id}`
            }

            if (res.data.code === 0){
                this.setState({
                    init: true,
                    liveroom: res.data.data
                });
                let data = res.data.data;

                document.title = data.liveroom.name;

                // 初始化邀请卡
                this.props.dispatch({
                    type: 'SHARECARD_INIT',
                    payload: {
                        type: 'liveroom_vip',
                        role: data.role,
                        id: data.liveroom.id,
                        is_resell: !!data.vip_info && ((data.vip_info.vip_fee * data.vip_info.vip_resell_persent / 100) > 1),
                        title: data.vip_info && ((data.vip_info.vip_fee * data.vip_info.vip_resell_persent / 100) > 1) && '赚' + renderMoney(data.vip_info.vip_fee * data.vip_info.vip_resell_persent / 100)
                    }
                });

                //微信分享sdk
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: data.share_info.share_title,
                        desc: data.share_info.share_description,
                        imgUrl: data.share_info.share_icon,
                        type: 'link',
                        link: data.share_info.share_url,
                        objectType: 'liveroom',
                        objectId: data.liveroom.id,
                        is_resell: !!data.vip_info,
                        liveroom_id: data.liveroom.id
                    }
                });

                //VIP会员自动调起支付
                let {query} = this.props.location;
                if (!(data.role.is_manager || data.role.is_liveroom_vip)) {
                    if (query.auto_pay && query.auto_pay === '1') {
                        this.auto_vip = setTimeout(() => {
                            this.handleVipPay()
                        },3000);
                    }
                }
            }
        })

        axios.get(`/api/liveroom/${liveroom_id}/channel_list`, {
            params: {
                limit: 10,
                offset: 0,
                only_vip: 1,
            }
        }).then((response) => {
            if (response.data.code === 0) {
                this.setState({
                    channel: response.data.data
                })
            }
        });

        axios.get(`/api/liveroom/${liveroom_id}/lecture_list`, {
            params: {
                limit: 10,
                offset: 0,
                only_vip: 1,
            }
        }).then((response) => {
            if (response.data.code === 0) {
                this.setState({
                    lecture: response.data.data
                })
            }
        })
    }

    componentWillUnmount() {
        this.auto_vip && clearTimeout(this.auto_vip);
    }

    showSuccessToast () {
        this.setState({ isShowSuccessToast: true })
        setTimeout(() => {
            this.setState({ isShowSuccessToast: false })
        }, 1000)
    }

    // oneShowVIPBtn (e) {
    //     if(!this.state.showVIPBtn){
    //         this.setState({showVIPBtn: true})
    //     }
    // }

    handleChannelLoadMore() {
        let params = {
            limit: 10,
            only_vip: 1,
        };

        params.offset = this.state.channel.next_offset;

        let {liveroom_id} = this.props.location.query;

        this.setState({
            channelLoading: true
        });

        axios.get(`/api/liveroom/${liveroom_id}/channel_list`, {params: params}).then((response) => {
            const {next_offset, has_more, channels, total_count} = response.data.data;
            if (response.data.code === 0) {
                this.setState({
                    channelLoading: false,
                    channel: {
                        has_more: has_more,
                        next_offset: next_offset,
                        channels: this.state.channel.channels.concat(channels),
                        total_count: total_count
                    }
                });
            }
        });
    }

    handleLectureLoadMore() {
        let params = {
            limit: 10,
            only_vip: 1,
        };

        params.offset = this.state.lecture.next_offset;

        let {liveroom_id} = this.props.location.query;

        this.setState({
            lectureLoading: true
        });

        axios.get(`/api/liveroom/${liveroom_id}/lecture_list`, {params: params}).then((response) => {
            const {next_offset, has_more, lectures, total_count} = response.data.data;
            if (response.data.code === 0) {
                this.setState({
                    lectureLoading: false,
                    lecture: {
                        has_more: has_more,
                        next_offset: next_offset,
                        lectures: this.state.lecture.lectures.concat(lectures),
                        total_count: total_count
                    }
                });
            }
        });
    }

    handleEnterVipList() {
        let {liveroom_id} = this.props.location.query;
        location.assign(`/liveroom/${liveroom_id}/paylist`)
    }

    handleVipPay() {
        let {liveroom_id} = this.props.location.query;
        let inviterId = this.props.location.query.inviter_id;
        let type = 'PAY_LIVEROOM';
        let params = {
            product: 'liveroom_vip',
            liveroom_id: liveroom_id,
        };
        if (inviterId){
            params = {
                product: 'liveroom_vip',
                liveroom_id: liveroom_id,
                inviter_id: inviterId,
            };
        }

        if (isLZWKAPP()) {
            window.payResult = (data) => {
                if (data.code === -1) {
                    return alert('支付失败')
                }
                if (data.code === 0) {
                    this.showSuccessToast()
                    updateSuccess({ type: 'liveroom' })
                    setTimeout(() => {
                        goBack()

                    }, 1000)
                }
            }
            let payParams = {}
            if (this.props.location.query.st) {
                payParams = { ...payParams, st: this.props.location.query.st }
            }
            if (this.props.location.query.inviter_id) {
                payParams = { ...payParams, inviter_id: this.props.location.query.inviter_id }
            }
            if (window.systemType === 'ios' && judgeAPPVersion(400)) {
                return this.handleIAPPay(params)
            }
            wxPay({
                id: liveroom_id,
                product: 'liveroom_vip',
                productField: 'liveroom_id',
                type: 'liveroom_vip',
                payParams,
            })
            return
        }

        //发起支付
        this.props.dispatch({
            type: type,
            payload: {
                params: params,
                success: () => {
                    // this.props.dispatch({
                    //     type: 'LIVEROOM_SET_VIP',
                    //     payload: {
                    //         role: {
                    //             is_liveroom_vip: true,
                    //         }
                    //     }
                    // });
                    // axios.get(`/api/liveroom/${liveroom_id}/vip/info`).then(res => {
                    //     if (res.data.code === 0){
                    //         this.setState({
                    //             init: true,
                    //             liveroom: res.data.data
                    //         });
                    //     }
                    // })
                    location.href = `/liveroom/${params.liveroom_id}/paysuccess?liveroom_id=${params.liveroom_id}`
                },
                fail: (data) => {
                    if (data.code === 2) {
                        this.context.page.showToast('已成为VIP');
                        this.props.dispatch({
                            type: 'LIVEROOM_SET_VIP',
                            payload: {
                                role: {
                                    is_liveroom_vip: true
                                }
                            }
                        });
                    }
                }
            }
        })
    }

    handleIAPPay (params) {
        this.setState({ isPending: true })
            axios.get(`/api/pay/iappay`, {
                params: {
                    ...params,
                    trade_type: 'IAP',
                },
            })
                .then(res => {
                    this.setState({ isPending: false })
                    if (res.data.code === 0) {
                        setTimeout(() => {
                            location.reload()
                        }, 1000)
                        return this.showSuccessToast()
                    }
                    if (res.data.code === 10001) {
                        return this.setState({ isShowNoEnoughAlert: true, noEnoughtMsg: `荔枝币余额仅有 ${renderMoney(res.data.data.balance)}，请前往冲值` })
                    }
                    alert(res.data.msg)
                })
    }

    handleCoupnPay() {
        let {liveroom_id} = this.props.location.query;
        let inviterId = this.props.location.query.inviter_id;
        let {newCoupon} = this.props;
        let type = 'PAY_LIVEROOM';

        let params = {
            product: 'liveroom_vip',
            liveroom_id: liveroom_id,
            discount_code: newCoupon.couponData.code,
            discount_id: newCoupon.couponData.id
        };
        if (inviterId){
            params = {
                product: 'liveroom_vip',
                liveroom_id: liveroom_id,
                inviter_id: inviterId,
                discount_code: newCoupon.couponData.code,
                discount_id: newCoupon.couponData.id
            };
        }

        if (isLZWKAPP()) {
            window.payResult = (data) => {
                if (data.code === -1) {
                    return alert('支付失败')
                }
                if (data.code === 0) {
                    this.showSuccessToast()
                    updateSuccess({ type: 'liveroom' })
                    setTimeout(() => {
                        goBack()

                    }, 1000)
                }
            }
            let payParams = {
                discount_code: newCoupon.couponData.code,
                discount_id: newCoupon.couponData.id
            }
            if (this.props.location.query.st) {
                payParams = { ...payParams, st: this.props.location.query.st }
            }
            if (this.props.location.query.inviter_id) {
                payParams = { ...payParams, inviter_id: this.props.location.query.inviter_id }
            }
            if (window.systemType === 'ios' && judgeAPPVersion(400)) {
                return this.handleIAPPay(params)
            }
            wxPay({
                id: liveroom_id,
                product: 'liveroom_vip',
                productField: 'liveroom_id',
                type: 'liveroom_vip',
                payParams,
                success: () => {
                    location.assign(`lizhiweike://liveroom?liveroom_id=${params.liveroom_id}`)
                }
            })
            return
        }

        //发起支付
        this.props.dispatch({
            type: type,
            payload: {
                params: params,
                success: () => {
                    location.href = `/liveroom/${params.liveroom_id}/paysuccess?liveroom_id=${params.liveroom_id}`
                    /*this.props.dispatch({
                        type: 'LIVEROOM_SET_VIP',
                        payload: {
                            role: {
                                is_liveroom_vip: true,
                            }
                        }
                    });
                    axios.get(`/api/liveroom/${liveroom_id}/vip/info`).then(res => {
                        if (res.data.code === 0){
                            this.setState({
                                init: true,
                                liveroom: res.data.data
                            });
                        }
                    })*/
                    // window.location = window.location;
                },
                fail: (data) => {
                    if (data.code === 2) {
                        this.context.page.showToast('已成为VIP');
                        this.props.dispatch({
                            type: 'LIVEROOM_SET_VIP',
                            payload: {
                                role: {
                                    is_liveroom_vip: true
                                }
                            }
                        });
                    }
                }
            }
        })
    }

    handleCouponPayShow(value) {
        this.setState({
            couponpay_show: typeof value === 'boolean' ? value : !this.state.couponpay_show
        })
    }

    handleHidePush() {
        this.setState({
            push_show: false
        })
    }

    renderTitleBar() {
        const {stats_info, role} = this.state.liveroom;
        if (role.is_manager){
            return (
                <div className="liveroom-vip-manager" onClick={() => this.handleEnterVipList()}>
                    <div className="vip-manager-item">
                        <p className="vip-manager-item-count">{stats_info.vip_account_num}</p>
                        <p>会员数(人)</p>
                    </div>
                    <div className="vip-manager-item">
                        <p className="vip-manager-item-price">{renderMoney(stats_info.vip_earn)}</p>
                        <p>总收益(元)</p>
                    </div>
                </div>
            )
        }
        // else {
            // if (role.is_liveroom_vip){
            //     return (
            //         <div>
            //             <LiveroomTitleBar title={'VIP会员'}/>
            //             <div className="title-price">
            //                 <div className="price-top">
            //                     <span>有效期至</span>
            //                     <span className="price-top-color">  {TimeStream(role.liveroom_vip_expired_timestamp, 'YMD')}</span>
            //                 </div>
            //                 <div className="price-text">
            //                     成为VIP会员，本店铺课程免费听
            //                 </div>
            //             </div>
            //         </div>
            //     )
            // }
            // else {
            //     return (
            //         <div>
            //             <LiveroomTitleBar title={'VIP会员费用'}/>
            //             <div className="title-price">
            //                 <div className="price-top">
            //                     <span>12个月</span>
            //                     <span className="price-top-color">  ￥{this.state.liveroom.vip_info && renderMoney(this.state.liveroom.vip_info.vip_fee)}</span>
            //                 </div>
            //                 <div className="price-text">
            //                     成为VIP会员，全场课程免费听
            //                 </div>
            //             </div>
            //         </div>
            //     )
            // }
        // }
    }

    renderList() {
        const {lecture, channel, channelLoading} = this.state;
        const loadingstatus = {
            ended: !channel.has_more,
            loading: channelLoading,
            has_more: channel.has_more,
            loadMethod: () => {
                this.handleChannelLoadMore()
            }
        };

        if (lecture.lectures.length === 0){
            if (channel.channels.length === 0){
                return (
                    <div>
                        <LiveroomTitleBar title={'VIP会员可收听以下课程' + `（${lecture && lecture.total_count}）`}/>
                        <div style={{color: '#999', fontSize: '14px', textAlign: 'center', padding: '10px 0',backgroundColor:'#fff'}} className="noClassBox">
                            {/* <img src="https://static-cos.lycheer.net/picture/4557647_e9685c7a12e1aa5fb0d576072a427c82.jpg" alt=""/>
                            <p>该店铺暂时没有VIP会员可访问的原创课程 <br/> 请点击右下角操作按钮创建课程</p> */}
                            该店铺暂时没有VIP会员可访问的原创课程
                        </div>
                    </div>
                )
            }else {
                return (
                    <div>
                        <LiveroomTitleBar title={'VIP会员可收听以下专栏' + `（${channel && channel.total_count}）`}/>
                        {channel.channels.map((list) => <WKCurrencyItem key={list.id} content={list} type={'channel'}/>)}
                        {channel.has_more &&
                        <ClickLoadMore loadingstatus={loadingstatus}/>
                        }
                    </div>
                )
            }
        }else {
            if (channel.channels.length === 0){
                return (
                    <div>
                        <LiveroomTitleBar title={'VIP会员可收听以下课程' + `（${lecture && lecture.total_count}）`}/>
                        {lecture.lectures.map((list) => <WKCurrencyItem key={list.id} content={list} type={'lecture'}/>)}

                        <InfiniteScroll
                            onTouchBottom={() => this.handleLectureLoadMore()}
                            distance={300}
                            isStop={this.state.lectureLoading}
                            isKill={!lecture.has_more}
                        />
                        {!lecture.has_more &&
                        <div className="liveroom-none-gap">
                            <div className="gap">
                                没有更多了
                            </div>
                        </div>
                        }
                    </div>
                )
            }else {
                return (
                    <div>
                        <LiveroomTitleBar title={'VIP会员可收听以下专栏' + `（${channel && channel.total_count}）`}/>
                        {channel.channels.map((list,index) => <WKCurrencyItem key={list.id} content={list} border={index == 0 && 'none'} type={'channel'}/>)}
                        {channel.has_more &&
                        <ClickLoadMore loadingstatus={loadingstatus}/>
                        }
                        <div style={{height: '10px'}}></div>
                        <LiveroomTitleBar title={'VIP会员可收听以下课程' + `（${lecture && lecture.total_count}）`}/>
                        {lecture.lectures.map((list, index) => <WKCurrencyItem key={list.id} border={index == 0 && 'none'} content={list} type={'lecture'}/>)}

                        <InfiniteScroll
                            onTouchBottom={() => this.handleLectureLoadMore()}
                            distance={300}
                            isStop={this.state.lectureLoading}
                            isKill={!lecture.has_more}
                        />
                        {!lecture.has_more &&
                        <div className="liveroom-none-gap">
                            <div className="gap">
                                没有更多了
                            </div>
                        </div>
                        }
                    </div>
                )
            }
        }

    }

    renderEditList() {
        return [
            {
                blockContent: {
                    img: PushLecture,
                    text: 'VIP推送',
                    method: () => {
                        this.setState({
                            push_show: true
                        })
                    }
                },
                hasContent: true
            },
        ]
    }

    onClickLiveroomBar (e) {
        if (isLZWKAPP()) {
            e.preventDefault()
            goBack()
        }
    }

    onClickTopup () {
        this.setState({ isShowNoEnoughAlert: false })
        location.assign('lizhiweike://iap_recharge')
    }

    render() {
        // ios审核屏蔽
        // if (isLZWKAPP() && isIos() && judgeAPPVersion(420)) {
        //     return (
        //         <div style={{textAlign: 'center', padding: '30px', color: '#fff'}}>VIP功能维护中，预计三小时后开放。感谢您的支持</div>
        //     )
        // }

        if (!this.state.init || !this.state.channel || !this.state.lecture){
            return <Preload/>
        }

        const {liveroom, vip_info, role} = this.state.liveroom;
        const {verify_type} = liveroom;
        const {canUseCouponBuy, couponData} = this.props.newCoupon
        const originVipFee = vip_info.vip_fee // 原价
        const realPrice = canUseCouponBuy ? (originVipFee - couponData.price) <= 0 ? 0 : (originVipFee - couponData.price) : originVipFee
        return (
            <Page>
                <div className="liveroom-vip-container" >
                    <div className="liveroom-vip-page" style={{paddingBottom: !role.is_manager ? '60px' : '0'}}>
                        <header>
                            <div className="header" onClick={!role.is_manager ? () => this.handleVipPay() : () => {}}>
                                {/* <div className="top">
                                    <img src={VipBG} alt=""/>
                                </div>
                                <div className="vip-card" style={{backgroundImage: `url(${VipCard})`}}>
                                    {role.is_liveroom_vip &&
                                    <div className="vip-card-content">
                                        <div className="vip-card-content-icon">
                                            <img src={this.props.account.small_avatar_url} alt=""/>
                                        </div>
                                        <div className="vip-card-content-message">
                                            <p>{this.props.account.nickname}</p>
                                            <p>{TimeStream(role.liveroom_vip_expired_timestamp, 'YMD')}</p>
                                        </div>
                                    </div>
                                    }
                                </div>  */}
                                <div className="picBox">
                                    <img src="https://static-cos.lycheer.net/picture/4557647_0613d84dee12c2a27139918da67698df.jpg" alt=""/>
                                </div>
                                <div className="headWordBox">
                                    <div className="wordTitle">
                                        <img src="https://static-cos.lycheer.net/picture/4557647_2d9eb3db078b901d732bb8ce8ac6c9bb.jpg" alt=""/>
                                    </div>
                                    {!role.is_liveroom_vip && !role.is_manager &&
                                        <div className="wordPrice">
                                            <p> <sup>￥</sup> {renderMoney(vip_info.vip_fee)}</p>
                                            <p>有效期：12个月</p>
                                        </div>
                                    }

                                </div>
                            </div>
                        </header>

                        <WKToShareCard/>

                         {this.renderTitleBar()}

                        <a onClick={e => this.onClickLiveroomBar(e)} href={`/liveroom/${liveroom.id}${window.location.search}`}>
                            <div className="liveroom-bar">
                                <div className="bar-icon">
                                    <img src={liveroom && liveroom.small_avatar_url} alt=""/>
                                    {
                                        verify_type === 2 &&
                                        <i className="iconfont verify-type-icon icon-yfv" style={{top: '20px', left: '20px'}}>
                                        </i>
                                    }
                                    {
                                        verify_type === 1 &&
                                        <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv" style={{top: '20px', left: '20px'}}>
                                        </i>
                                    }
                                </div>
                                <div className="bar-name">
                                    {liveroom && liveroom.name}
                                </div>
                                <div className="bar-entry">
                                    <span>查看课程</span>
                                    <div className="entry-angle">
                                        <img src={LiveroomBarAngle} alt=""/>
                                    </div>
                                </div>
                            </div>
                        </a>

                        {this.props.newCoupon.hasCoupon && !role.is_manager && !role.is_liveroom_vip &&
                        <CouponBar type="liveroom" target_id={liveroom.id} shouldTop={true} vip_info={vip_info} />
                        }


                        {!role.is_manager &&
                        <CouponSelected payMethod={() => {
                            this.props.dispatch({
                                type: 'COUPON_SELECT_HIDE'
                            });
                            this.setState({
                                couponpay_show: false
                            });
                            this.handleVipPay();
                        }} type="liveroom" target_id={liveroom.id} vip_info={vip_info} />
                        }

                        <LiveroomTitleBar title={'VIP会员权益'}/>
                        <div className="vip-info">
                            <div className="vip-info-item">
                                <div className="info-img">
                                    <img src="https://static-cos.lycheer.net/picture/4557647_8b4e0a1248fbb1f37e59202c8d45f2d5.jpg" alt=""/>
                                </div>
                                <div className="info-title">
                                    <p>本店铺课程免费收听</p>
                                    <p> <span>本店铺内所有原创课程免费收听</span>
                                    ，优质好课不断更新，支持有效期内无限次回听（转载课和加密课除外）</p>
                                </div>
                                {/* <div className="info-text">
                                    店铺内所有原创课程免费收听，优质好课不断更新，
                                    <br />
                                    购买期限内支持反复收听（转播课和加密课除外）
                                </div> */}
                            </div>
                            <div className="vip-info-item">
                                <div className="info-img">
                                    <img src="https://static-cos.lycheer.net/picture/4557647_60bea4e9ae1eedd62af4a234096e4b3a.jpg" alt=""/>
                                </div>
                                <div className="info-title">
                                    <p>尊贵标识</p>
                                    <p>VIP会员在店铺尽显尊贵特殊身份，课程内容无限畅享</p>
                                </div>
                                {/* <div className="info-text">
                                    VIP会员在店铺尽显尊贵身份，课程内容无限畅享
                                </div> */}
                            </div>
                        </div>

                        <LiveroomTitleBar title={'VIP会员介绍'}/>
                        <div className="vip-info-manager-text">
                        {
                            // vip_info.vip_desc === '' ?
                            // <div className="noContentBox">
                            //     <img src="https://static-cos.lycheer.net/picture/4557647_c310e10b18de04e1da60aab8d1d4e616.jpg" alt=""/>
                            //     <p>点击右下角操作按钮 <br/> 攥写VIP会员介绍，提高购买率</p>
                            // </div>
                            // :
                            <pre>
                                {vip_info.vip_desc}
                            </pre>
                        }

                        </div>

                        {this.renderList()}
                    </div>

                    <Pay handleCouponPayShow={this.handleCouponPayShow} realPrice={realPrice}/>

                    {!role.is_manager &&
                    <div className="liveroom-vip-bottom-bar"
                        >
                        {!role.is_liveroom_vip &&
                            <span className="open_vip_btn" onClick={() => this.props.newCoupon.canUseCouponBuy ? this.handleCouponPayShow() : this.handleVipPay()}> 立即开通VIP会员</span>
                        }
                        {role.is_liveroom_vip &&
                            <div className="isVIPBox">
                                <div className="vipDataBox">
                                    <span>VIP有效期至{TimeStream(role.liveroom_vip_expired_timestamp, 'YMD')}</span>
                                </div>
                                <div className="renewalsBox"  onClick={() => this.props.newCoupon.canUseCouponBuy ? this.handleCouponPayShow() : this.handleVipPay()}>
                                    <span>续费￥{renderMoney(vip_info.vip_fee)}</span>
                                </div>
                            </div>
                        }
                    </div>
                    }


                    {this.state.couponpay_show &&
                    <CouponPay
                        oldPrice={vip_info.vip_fee}
                        targetContent={liveroom}
                        coupon={this.props.newCoupon.couponData}
                        handleClose={() => this.handleCouponPayShow()}
                        btnMethod={() => this.handleCoupnPay()}
                    />
                    }

                    {role.is_manager &&
                    <div>
                        {this.state.push_show &&
                        <PushComponent type={'liveroom'} target_id={liveroom.id}
                                       handleHidePush={() => this.handleHidePush()}/>
                        }
                        <WKOperation editList={this.renderEditList()}/>
                    </div>
                    }
                </div>
                <Toast icon="success-no-circle" show={this.state.isShowSuccessToast}>购买成功</Toast>
                <Toast icon="loading" show={this.state.isPending}>请求中...</Toast>
                <WKOwnDialog type="ios" title='余额不足' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowNoEnoughAlert: false }) },
                    { label: '充值', onClick: () => this.onClickTopup() }
                ]} show={this.state.isShowNoEnoughAlert}>
                    {this.state.noEnoughtMsg}
                </WKOwnDialog>
            </Page>
        )
    }
}

export default connect(state => ({
    account: state.account,
    newCoupon: state.newCoupon,
}))(LiveroomVipPage)



// WEBPACK FOOTER //
// ./src/pages/LiveroomVipPage.js